import {useState} from "react";
import {useDispatch} from "react-redux";
import {EMPTY_VALUES, getDateFormat} from "../../../../Apis/functions";
import {SearchByFilters} from "../../../../reduxToolkit/Search/SearchApi";
import CustomTh from "../../../../components/table/CustomTh";
import CustomTd from "../../../../components/table/CustomTd";
import TableFunction from "../../../../components/table/TableFunction";
import {userTypeDrop} from "../../../../enums/userTypeEnumDrop";
import CustomImageTable from "../../../../components/CustomImageTable";
import checkIcon from "../../../../assets/icon/checkIcon.svg";
import cancelIcon from "../../../../assets/icon/cancelIcon.svg";
import {TABLES} from "../../../../Apis/Tables";
import {CRITERIA_MODEL} from "../../../../components/table/Model/TableModel";
/**
 * @Author: Karen Yunuen Pozos Arias
 * @JobTitle: Full Stack Developer - IBL
 * @Email: kpozos@ibl.mx
 */
const AccessLogsTableApp = ({finalArray, modified, setModified}) =>
{
    const dispatch = useDispatch();
    const [tableId, setTableId] = useState("tbl_lt_supplier_docs");
    const [results, setResults] = useState({ content: [], totalElements: 0 });

    //Returns an array of table header elements
    const getThead = () => {
        return [
            <CustomTh tableId={tableId} fixedXY={true} left={0} classes="first_head">{t('name')}</CustomTh>,
            <CustomTh tableId={tableId}>{t('last_name')}</CustomTh>,
            <CustomTh tableId={tableId}>{t('second_last_name')}</CustomTh>,
            <CustomTh tableId={tableId}>{t('user_type')}</CustomTh>,
            <CustomTh tableId={tableId}>{t('successful_attempt')}</CustomTh>,
            <CustomTh tableId={tableId}>{t('platform')}</CustomTh>,
            <CustomTh tableId={tableId}>{t('date')}</CustomTh>
        ];
    }
    //Returns an object with the body components
    const getTbody = () => {
        if(!results || results?.totalElements === 0 || results?.length === 0)  return {
            body: [],
            data: []
        };

        let body =  results?.content?.map((item, index) => {
            return (
                <>
                    <CustomTd tableId={tableId} fixed={true} left={0} classes={"first-column"}>
                        {item?.userName}
                    </CustomTd>
                    <CustomTd tableId={tableId} >{item?.userLastName}</CustomTd>
                    <CustomTd tableId={tableId} >{item?.secondLastName}</CustomTd>
                    <CustomTd tableId={tableId} >{t(userTypeDrop[item?.userTypeId]).toLocaleUpperCase()}</CustomTd>
                    <CustomTd tableId={tableId} ><CustomImageTable text={""} image={item?.wasSuccessfully ? checkIcon : cancelIcon}/></CustomTd>
                    <CustomTd tableId={tableId} >{t(item?.platform?.toLowerCase()).toLocaleUpperCase()}</CustomTd>
                    <CustomTd tableId={tableId} >{getDateFormat(item?.createdAt) || EMPTY_VALUES.DEFAULT}</CustomTd>
                </>
            );
        });

        return {
            body: body,
            data: results?.content
        }
    };

    const getActionsButtons = () => {
        return <></>;
    }

    /**
     * Executes a paginated search request using basic criteria.
     *
     * Builds the request body with the current page, page size, selected model,
     * and any additional criteria passed as arguments.
     * Triggers the search action through Redux and updates the results on success.
     */
    const getData = (page) => {
        const criteriaList = finalArray.map((item) => {
            return CRITERIA_MODEL.set(item);
        });

        const body = {
            pagination: {
                page: page,
                size: rowsPerPage,
            },
            searchCriteriaList: criteriaList,
        };

        dispatch(SearchByFilters({ option:`${TABLES.LOG_IN_LOG}`, body })).then(
            ({payload: {data: { data, success }}}) => {
                if (success === true) {
                    setResults(data);
                }
            },
        );
    }

    // Setup table functions and pagination using shared TableFunction logic
    const {t, thead, tbody, pagination, rowsPerPage} = TableFunction({
        data: results,
        getThead,
        getTbody,
        labelRowsPerPage:'platform_access_per_page',
        hasContainer:true,
        fixedPagination:false,
        getData,//New
        modified,//New
        setModified,//New
   
    });

    return {
        tableId,
        thead,
        tbody,
        getActionsButtons,
        pagination
    };

}
export default AccessLogsTableApp;
